import { useRentalManagerUserPropertyMultiplexWebApiHandler_unitPublished } from '@zg-rentals/ts-rental-manager-api-beta-client-react-query';

import useMultiplexBuildingSessionId from './useMultiplexBuildingSessionId';

import type { UserPropertyMultiplexUnitPublishedResponseWebDto } from '@zg-rentals/ts-rental-manager-api-beta-client';

type UseMultiplexUnitPublishedArgs = {
  listingAlias: string | null | undefined;
};

/**
 * Fetches multiplex unit-published summary (published unit, unpublished count, next unit) after a unit goes live.
 */
const useMultiplexUnitPublished = ({
  listingAlias,
}: UseMultiplexUnitPublishedArgs): {
  data: UserPropertyMultiplexUnitPublishedResponseWebDto | undefined;
  error: unknown;
  isFetching: boolean;
} => {
  const { multiplexBuildingSessionId } = useMultiplexBuildingSessionId();

  const { data, error, isFetching } = useRentalManagerUserPropertyMultiplexWebApiHandler_unitPublished(
    {
      multiplexBuildingSessionId: multiplexBuildingSessionId ?? '',
      listingAlias: listingAlias ?? '',
    },
    {
      enabled: Boolean(multiplexBuildingSessionId && listingAlias),
      meta: {
        tags:
          multiplexBuildingSessionId && listingAlias
            ? ['multiplexUnitPublished', multiplexBuildingSessionId, listingAlias]
            : ['multiplexUnitPublished'],
        context: {
          api: 'useRentalManagerUserPropertyMultiplexWebApiHandler_unitPublished',
          details: 'useMultiplexUnitPublished',
        },
      },
    },
  );

  return {
    data,
    isFetching,
    error,
  };
};

export default useMultiplexUnitPublished;
